export interface CsvColumn {
  key: string;
  label: string;
}

/** RFC 4180 field quoting; also defuses spreadsheet formulas (=, +, -, @). */
export function csvField(value: unknown): string {
  if (value === null || value === undefined) return '';
  let text = value instanceof Date ? value.toISOString() : String(value);
  if (/^[=+\-@\t\r]/.test(text) && !/^-?\d+(\.\d+)?$/.test(text)) text = `'${text}`;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/**
 * A CSV document, starting with a UTF-8 byte-order mark so Excel opens Hebrew
 * names correctly. Mirrors backend/staff/src/utils/csv.ts.
 */
export function toCsv(columns: CsvColumn[], rows: Record<string, unknown>[]): string {
  const lines = [columns.map((c) => csvField(c.label)).join(',')];
  for (const row of rows) lines.push(columns.map((c) => csvField(row[c.key])).join(','));
  return `﻿${lines.join('\r\n')}\r\n`;
}

/** Hand a file to the browser as a download. */
export function downloadFile(filename: string, content: string | Blob, type = 'text/csv;charset=utf-8'): void {
  const blob = content instanceof Blob ? content : new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
